import React, { Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Loader from './component/Spin.jsx';
import AppLayout from './screens/appLayout/AppLayout.jsx';
import LoginRoute from './screens/auth/LoginRoute.jsx';

const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route path='/login' component={LoginRoute} />
          <Route path='/' component={AppLayout} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};
export default App;
